import React, {Component} from 'react';

import axios from 'axios';
var moment = require('moment');

require(`../assets/${process.env.PAGE}/css/components/TempLink.css`);

class TempLink extends Component {
    constructor(props){
        super(props);

        this.state = {
            seconds: props.seconds,
            secondsToWait: 120,
        }

        this.manageTimer = this.manageTimer.bind(this);
        this.performAction = this.performAction.bind(this);
    }

    componentDidMount() {
        if (this.state.seconds > 0){
            this.timer = setInterval(this.manageTimer, 1000);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.seconds <= 0 && this.state.seconds > 0){
            this.timer = setInterval(this.manageTimer, 1000);
        }
    }

    manageTimer() {

        const { seconds } = this.state;

        this.setState({
            seconds: seconds -1,
        });

        if((seconds - 1) <= 0){
            clearInterval(this.timer);
        }
    }

    performAction(event){
        const { secondsToWait } = this.state;
        this.props.onTime();
        this.setState({
            seconds: secondsToWait
        });
    }

    castSecondsToMinute(seconds){
        return moment().startOf('day').add(seconds, 'seconds').format('mm:ss')
    }

    render() {
        const { url, actionText } = this.props;
        const { seconds } = this.state;
        const actionLink = seconds > 0 ? (<div className='wait-msg'><p><span className='custom-orange-font'>{`Por favor esperá ${this.castSecondsToMinute(seconds)} minutos`}</span></p></div>) : (<p><a className={'btn btn-re-action'} onClick={this.performAction}>{actionText}</a></p>);
        return (<span><p>{this.props.children}{actionLink}</p></span>);
    }
}

export default TempLink;


/** WEBPACK FOOTER **
 ** ./src/components/TempLink.js
 **/